import { useDispatch, useSelector } from 'react-redux';
import '../../css/base.css';
import TheCottage from './theCottage';
import GettingThere from './gettingThere';
import ContactUs from './contactUs';
import Access from './access';
import Bedrooms from './bedrooms';
import Wifi from './wifi';
import Finally from './finally';
import Heating from './heating';
import Kitchen from './kitchen';
import Leaving from './leaving';
import LivingRoom from './livingRoom';
import Miscellaneous from './miscellaneous';
import Shopping from './shopping';
import Kayaks from './kayaks';
import Outdoors from './outdoors';
import Parking from './parking';
import Pets from './pets';
import ThingsToDo from './thingsToDo';
import welcome3a from '../../img/welcome3a.jpg';
import gallery3 from '../../img/gallery3.jpg';
import gallery4 from '../../img/gallery4.jpg';
import arnisdale_small from '../../img/arnisdale_small.jpg';
import arnisdale_medium from '../../img/arnisdale_medium.jpg';
import arnisdale_large from '../../img/arnisdale_large.jpg';
import { setPage} from '../../store/AppSlice';

const YourStay = () => {

  window.scrollTo(0,0);
  const dispatch = useDispatch();
  const appstate = useSelector((state) => state.appState);
  
  const navigateToLocation = () => {
    dispatch(setPage("LOCATION"));
  }

  const navigateToContact = () => {
    dispatch(setPage("CONTACT"));
  }

  const isVIP = () => {
    if (appstate.vip === true) {
      return (
        <div className="col-12 col-md-6 order-9 imagesBackgroundColour">
          <div className="generalText">
            <div className="generalTextBox">
              <Kayaks />
            </div>
          </div>
        </div>       )
    } 
  }

  return (
    <div className="row">
      <div className="col-12 col-md-6 col-lg-4 order-1 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <TheCottage />
            <GettingThere />
            <Access />
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 col-lg-8 order-2 imagesBackgroundColour no-padding">
          <img src={welcome3a} alt="Shore Cottage" className="gallery-image" />
      </div>
      <div className="col-12 col-md-6 order-3 order-md-4 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <Bedrooms />
            <Wifi />
            <LivingRoom />
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 order-4 order-md-3 imagesBackgroundColour no-padding">
          <img src={gallery3} alt="Living Room" className="gallery-image" />
      </div>
      <div className="col-12 col-md-6 order-5 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <Kitchen />
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 order-6 imagesBackgroundColour no-padding">
          <img src={gallery4} alt="Kitchen" className="gallery-image" />
      </div>        
      <div className="col-12 col-md-6 order-7 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <Heating />
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 order-8 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <Miscellaneous />
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 order-9 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <Outdoors />
            <Parking />
            <Pets />
            <ThingsToDo />
          </div>
        </div>
      </div>
      {isVIP()}
      <div className="col-12 col-md-6 order-10 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <Shopping />
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 order-11 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <ContactUs />
            <Leaving />
          </div>
        </div>
      </div>
      <div className="col-12 col-md-12 order-12 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <Finally />
          </div>
        </div>
      </div>

      <div className="col-12 col-md-12 order-12 imagesBackgroundColour no-padding">
        <picture>
          <source srcset={`${arnisdale_small} 1x,${arnisdale_medium} 2x`} media="(max-width: 600px)" />
          <img srcset={`${arnisdale_medium} 1x,${arnisdale_large} 2x`}
            src={arnisdale_large} alt="Arnisdale Panorama" className="image"
          />
        </picture>
    </div>
    </div>
  );
}
export default YourStay
